// https://github.com/AzureAD/azure-activedirectory-library-for-js/blob/master/lib/adal.js
import AuthenticationContext from 'adal-angular/lib/adal.js';
import api from "./api";
import router from "../router";
import store from "../store";

//Azure Ad Config
const config = {
    tenant: process.env.VUE_APP_TENANT,
    clientId: process.env.VUE_APP_CLIENT_ID,
    redirectUri: process.env.VUE_APP_REDIRECT_URI,
    postLogoutRedirectUri: process.env.VUE_APP_REDIRECT_URI + "/loggedout", // Note that the comunet internal AD overrides this
    cacheLocation: 'localStorage',
    expireOffsetSeconds: 1800 // Any requests using the token within 30mins will result in a refreshed token (when calling acquireToken)
};

export default {
    authenticationContext: null,
    /**
     * Init Azure ADAL
     * @return {Promise}
     */
    initialize() {
        this.authenticationContext = new AuthenticationContext(config);

        return new Promise((resolve, reject) => {
            if (this.authenticationContext.isCallback(window.location.hash) || window.self !== window.top) {
                // redirect to the location specified in the url params.
                this.authenticationContext.handleWindowCallback();
            } else {
                // try pull the user out of local storage
                let user = this.authenticationContext.getCachedUser();

                if (user) {
                    resolve();
                } else {
                    reject();
                }
            }
        });
    },
    lastUsedToken: null,
    /**
     * Acquire Token
     */
    acquireToken() {
        let that = this;

        return new Promise((resolve, reject) => {
            this.authenticationContext.acquireToken(config.clientId, (error, token) => {
                if (error || !token) {
                    reject({
                        tokenError: error
                    });
                    return;
                }

                // If the token has changed, then refresh the user too
                if(that.lastUsedToken != null && that.lastUsedToken != token){
                     // Important that we update the last user token before refreshing the user
                     // because refreshing the user will use the updated token in its request
                    that.lastUsedToken = token;

                    // Refresh the user
                    that.processLogin().then(() => {
                        resolve(token);
                    }, () => {
                        reject({
                            userError: true
                        });
                    });
                    return;
                }

                that.lastUsedToken = token;
                resolve(token);
                return;
            });
        });
    },
    /**
     * @return An ADAL user profile .
     */
    getADProfile() {
        if (this.authenticationContext && this.authenticationContext.getCachedUser() && this.authenticationContext.getCachedUser().profile) {
            var profile = this.authenticationContext.getCachedUser().profile;
            return profile;
        } else {
            return "";
        }
    },
    /**
     * Sign in
     */
    signIn() {
        // Delete user in case still exists
        store.commit("authStore/removeUser");

        this.authenticationContext.login();
    },
    needToProcessLogin(){
        return !store.getters["authStore/getUserProfile"];
    },
    processLogin(){
        let that = this;

        return new Promise(function (resolve, reject) {
            let ADProfile = that.getADProfile();
            if(!ADProfile){
                // Invalid AD Profile
                that.forgetUser();
                reject();
                return;
            }

            api.getUser({
                success: function(response){
                    store.commit("authStore/updateUser", response.data);

                    resolve();
                },
                error: function(response){
                    // Something went wrong
                    that.forgetUser();
                    reject();
                }
            });
        });
    },
    hasPermissions(requiredPermissions){
        var permissions = store.getters["authStore/getPermissions"];

        if(permissions["admin"] && permissions["access"]){
            return true;
        }
        console.log('permissions: ' + permissions);

        for(var i = 0; i < requiredPermissions.length; i++){
            if(!permissions[requiredPermissions[i]]){
                return false;
            }
        }

        return true;
    },
    hasAccessToStore(requiredStoreID){
        var permissions = store.getters["authStore/getPermissions"];
        
        // Admins have access to everything
        if(permissions["admin"] && permissions["access"]){
            return true;
        }

        var stores = store.getters["authStore/getStores"];

        let hasAccessToRequiredStore = stores.find(storeID => storeID == requiredStoreID);
        if(!hasAccessToRequiredStore){
            return false;
        }

        return true;
    },
    hasAccessToDepartment(requiredDepartmentID){
        var permissions = store.getters["authStore/getPermissions"];

        // Admins have access to everything
        if(permissions["admin"] && permissions["access"]){
            return true;
        }

        var departments = store.getters["authStore/getDepartments"];

        let hasAccessToRequiredDepartment = departments.find(departmentID => departmentID == requiredDepartmentID);
        if(!hasAccessToRequiredDepartment){
            return false;
        }

        return true;
    },
    forgetUser(){
        store.commit("authStore/removeUser");
    },
    /**
     * Sign out
     */
    signOut() {
        // Delete user as is now not relevant
        this.forgetUser();

        this.authenticationContext.logOut();
    },
}
